import useNotRefValidations from "@saleor/createOrChangeNotRefContract/hooks/useNotRefValidations";
import { useFormik } from "formik";

const useOneTimeFormiks = (
  otc: any,
  isSubmitted: boolean,
  soldToCode?: string
) => {
  const { ShipToBillToSchema, OneTimeToSchema } = useNotRefValidations(false);
  const otcShipTo = useFormik<NotRefShipToOneTime>({
    initialValues: {
      soldToCode: otc?.soldToCode || soldToCode,
      name1: otc?.name1 || "",
      street1: otc?.street1 || "",
      street2: otc?.street2 || "",
      countryCode: otc?.countryCode || "TH",
      countryName: otc?.countryName || "THAILAND",
      city: otc?.city || "",
      district: otc?.district || "",
      subDistrict: otc?.subDistrict || "",
      postalCode: otc?.postalCode || "",
      transportZoneCode: otc?.transportZoneCode || "",
      transportZoneName: otc?.transportZoneName || "",
      telephoneNo: otc?.telephoneNo || "",
      telephoneExtension: otc?.telephoneExtension || "",
      language: otc?.language || "",
      mobileNo: otc?.mobileNo || "",
      faxNo: otc?.faxNo || "",
      faxNoExt: otc?.faxNoExt || "",
      location: otc?.location || "",
      email: otc?.email || ""
    },
    validationSchema: ShipToBillToSchema.omit(["taxId", "branchId"]),
    enableReinitialize: true,
    validateOnMount: false,
    validateOnChange: isSubmitted ? true : false,
    onSubmit: () => {
      //
    }
  });
  const otcBillTo = useFormik<NotRefBillToOneTime>({
    initialValues: {
      soldToCode: otc?.soldToCode,
      name1: otc?.name1 || "",
      street1: otc?.street1 || "",
      street2: otc?.street2 || "",
      countryCode: otc?.countryCode || "TH",
      countryName: otc?.countryName || "THAILAND",
      city: otc?.city || "",
      district: otc?.district || "",
      subDistrict: otc?.subDistrict || "",
      postalCode: otc?.postalCode || "",
      telephoneNo: otc?.telephoneNo || "",
      telephoneExtension: otc?.telephoneExtension || "",
      transportZoneCode: otc?.transportZoneCode || "",
      transportZoneName: otc?.transportZoneName || "",
      language: otc?.language || "",
      mobileNo: otc?.mobileNo || "",
      faxNo: otc?.faxNo || "",
      faxNoExt: otc?.faxNoExt || "",
      location: otc?.location || "",
      email: otc?.email || "",
      taxId: otc?.taxId || "",
      branchId: otc?.branchId || "",
      taxNumber1: otc?.taxNumber1 || "",
      taxNumber2: otc?.taxNumber2 || ""
    },
    validationSchema: ShipToBillToSchema,
    enableReinitialize: true,
    validateOnMount: false,
    validateOnChange: isSubmitted ? true : false,
    onSubmit: () => {
      //
    }
  });

  const formikOneTimeSoldTo = useFormik<NotRefOneTimeSoldTo>({
    initialValues: {
      soldToCode: otc?.soldToCode,
      paymentTerm: "AP00",
      taxClass: "",
      salesEmployee: "",
      name1: otc?.name1 || "",
      street1: otc?.street1 || "",
      street2: otc?.street2 || "",
      countryCode: otc?.countryCode || "TH",
      countryName: otc?.countryName || "THAILAND",
      city: otc?.city || "",
      district: otc?.district || "",
      subDistrict: otc?.subDistrict || "",
      postalCode: otc?.postalCode || "",
      telephoneNo: otc?.telephoneNo || "",
      telephoneExtension: otc?.telephoneExtension || "",
      transportZoneCode: otc?.transportZoneCode || "",
      transportZoneName: otc?.transportZoneName || "",
      language: otc?.language || "th",
      mobileNo: otc?.mobileNo || "",
      faxNo: otc?.faxNo || "",
      faxNoExt: otc?.faxNoExt || "",
      location: otc?.location || "",
      email: otc?.email || "",
      taxId: otc?.taxId || "",
      branchId: otc?.branchId || "",
      taxNumber1: otc?.taxNumber1 || "",
      taxNumber2: otc?.taxNumber2 || ""
    },
    validationSchema: OneTimeToSchema,
    enableReinitialize: true,
    validateOnMount: false,
    validateOnChange: isSubmitted ? true : false,
    onSubmit: () => {
      // Handle form submission action here, or leave it empty
    }
  });

  return {
    otcShipTo,
    otcBillTo,
    formikOneTimeSoldTo
  };
};

export default useOneTimeFormiks;
